import {Image} from '@shopify/hydrogen';
import {useFormatDate} from '../../hooks/useFormatDate';
import PortableText from '../portableText/PortableText.client';

type Props = {
  title: string;
  excerpt: string;
  featuredImage: any;
  date: string;
  content: any[];
};

export default function BlogContent({
  title,
  date,
  featuredImage,
  excerpt,
  content,
}: Props) {
  const formattedDate = useFormatDate(date);
  return (
    <div className="grid grid-cols-14 py-space-l">
      <div className="col-start-2 col-end-14 md:col-start-3 md:col-end-13">
        <h5 className="blockH5 font-bold">{formattedDate}</h5>
        <h1 className="blockH3 font-bold text-orange">{title}</h1>
        <div className="my-7 h-[3px] w-1/3 bg-orange md:my-20" />
        <h5 className="richH5">{excerpt}</h5>
        <Image
          width="inherit"
          height="inherit"
          data={featuredImage?.asset}
          alt={title}
          className="my-12 w-full md:my-25"
        />
        <PortableText blocks={content} />
      </div>
    </div>
  );
}
